import {
  Component,
  OnInit,
  OnDestroy,
  ChangeDetectorRef,
  ChangeDetectionStrategy,
  inject,
} from '@angular/core';
import { Model } from 'src/app/shared/models/clux/model-legacy';
import { CommonConstants } from '../constants/common.constant';
import { EmitterService } from '../services/emitter.service';
import { Subscription } from 'rxjs';
import { HeaderComponent } from '../components/header/header.component';
import { TascGrowelComponent } from '../components/tasc-growel/tasc-growel.component';
import { RouterOutlet } from '@angular/router';
import { FooterComponent } from '../components/footer/footer.component';

@Component({
  selector: 'app-layout',
  templateUrl: './layout.component.html',
  styleUrls: ['./layout.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [HeaderComponent, TascGrowelComponent, RouterOutlet, FooterComponent],
})
export class LayoutComponent implements OnInit, OnDestroy {
  private _emitter = inject(EmitterService);
  private cdr = inject(ChangeDetectorRef);

  public isAlertOpen: boolean;
  public tascGrowlObj: Model.growlProps;
  public hasGrowlerMargin = false;
  private subscriptions = new Subscription();

  public ngOnInit(): void {
    this.isAlertOpen = false;

    this.subscriptions.add(
      this._emitter.on(CommonConstants.emitterKeys.loginErrors).subscribe((msgObj: Model.growlProps) => {
        if (msgObj) {
          setTimeout(() => {
            this.tascGrowlObj = msgObj;
          });
        }
      })
    );

    this.subscriptions.add(
      this._emitter.getFixedGrowlerDisplayed().subscribe((isDisplayed) => {
        this.hasGrowlerMargin = isDisplayed;
        this.cdr.detectChanges();
      })
    );
  }

  public ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }

  public onToggleAlert(isAlertOpen: boolean): void {
    this.isAlertOpen = isAlertOpen;
  }
}
